
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inclusion-and-diversity",
      function () {
        return require("private-next-pages/inclusion-and-diversity.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inclusion-and-diversity"])
      });
    }
  